import PageSection from '../PageSection';

const AboutHeader = () => {
  return (
    <PageSection backgroundColor='blue'>
        <div>
            <h2>Welcome to</h2>
            <h1>Magic Tailor's</h1>
        </div>
    </PageSection>
  );
}



export default AboutHeader;